import styled from "styled-components";
export const CheckboxLabel = styled.span `
  font-size: 1rem;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
`;
